// extracted by mini-css-extract-plugin
export default {"root":"collapse-block__root_thTA5","chevron":"collapse-block__chevron_uqjLT","open":"collapse-block__open_tcowx"};